import React, { useRef, useState, useEffect } from "react";
import {
  ButtonCancel,
  ButtonCreate,
  ContentCreateSpeaker,
  ContentFields,
  ContentField,
  ContentButtons,
  ContentFile,
} from "./CreateSpeakerComponent.styled";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import FileUpload from "../FileUpload";
import { NotificationManager } from "react-notifications";

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: "0 0 0 0.2rem rgb(0 123 255 / 25%)",
    },
  }),
};
const CreateSpeakerComponent = ({ createNewSpeaker, action, cancelFn }) => {
  let countries = require("country-list");

  const [, setDataBulkUpload] = useState([]);
  const [files, setFiles] = useState({});

  const [RenderAgain, setRenderAgain] = useState(false);
  const [countriesIso, setcountriesIso] = useState([]);
  const name = useRef();
  const lastname = useRef();
  const position = useRef();
  const email = useRef();
  const company = useRef();
  const country = useRef();
  const description = useRef();

  const [folderName] = useState("Speakers");

  const removeSpace = (obj) => {
    obj.ref.current.value = obj.ref.current.value.replace(/ /g, "");
    setRenderAgain(!RenderAgain);
  };

  const executefn = () => {
    setTimeout(() => {
      setRenderAgain(!RenderAgain);
    }, 100);
  };

  let fields = [
    {
      type: "text",
      label: "First Name",
      ref: name,
      fn: setRenderAgain,
      placeholder: "Please enter your first name",
      regexp: /[¡!¿?=\-+*()/[\]&%|$#."_@]/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "Last Name",
      ref: lastname,
      fn: setRenderAgain,
      placeholder: "Please enter your last name",
      regexp: /[¡!¿?=\-+*()/[\]&%|$#."_@]/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "Position",
      ref: position,
      fn: setRenderAgain,
      placeholder: "Please enter your position",
      regexp: /[¡!¿?=\-+*()/[\]&%|$#."_@]/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "Email",
      ref: email,
      fn: removeSpace,
      placeholder: "Please enter your email",
      regexp: /^[^@]+@[^@]+\.[A-Z]+$/i,
      mandatory: true,
    },
    {
      type: "text",
      label: "Company",
      ref: company,
      fn: setRenderAgain,
      placeholder: "Please enter your company",
      mandatory: false,
    },
    {
      type: "select",
      label: "Country",
      ref: country,
      fn: executefn,
      placeholder: "Please select a country",
      // data: countries ? countries.countryByClient : [],
      data: countriesIso,
      mandatory: true,
    },
    {
      type: "textarea",
      label: "Description",
      ref: description,
      fn: setRenderAgain,
      placeholder: "Please enter a description",
      mandatory: true,
    },
  ];

  const renderInputs = (obj, index) => {
    switch (obj.type) {
      case "select":
        return (
          <ContentField key={index}>
            <Form.Label style={{ color: themeConfig.primary.icon }}>
              {obj.label}
              {obj.mandatory && <span style={{ color: "red" }}> *</span>}
            </Form.Label>{" "}
            <Select
              styles={customStyles}
              placeholder={obj.placeholder}
              ref={obj.ref}
              options={obj.data}
              onChange={() => obj.fn()}
            />
            {obj.ref.current &&
              obj.ref.current.state.ariaSelection?.value != null && (
                <CheckIcon
                  style={{
                    color: "white",
                    background: "rgba(51, 207, 141, 1)",
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
          </ContentField>
        );
      case "text":
      case "textarea":
        return (
          <ContentField
            key={index}
            style={{ gridColumn: obj.type === "textarea" ? "1/3" : "" }}
          >
            <Form.Label style={{ color: themeConfig.primary.icon }}>
              {obj.label}
              {obj.mandatory && <span style={{ color: "red" }}> *</span>}
            </Form.Label>{" "}
            {obj.type === "textarea" && (
              <Form.Control
                as="textarea"
                rows={5}
                ref={obj.ref}
                placeholder={obj.placeholder}
                onChange={() =>
                  obj.label === "Email" ? obj.fn(obj) : obj.fn(!RenderAgain)
                }
              // onBlur={() => changeDataFilter()}
              />
            )}
            {obj.type === "text" && (
              <Form.Control
                type="text"
                ref={obj.ref}
                placeholder={obj.placeholder}
                onChange={() =>
                  obj.label === "Email" ? obj.fn(obj) : obj.fn(!RenderAgain)
                }
              // onBlur={() => changeDataFilter()}
              />
            )}
            {obj.ref.current &&
              obj.ref.current.value &&
              obj.regexp &&
              ((obj.label === "Email" &&
                obj.regexp.test(obj.ref.current.value)) ||
                (obj.label !== "Email" &&
                  !obj.regexp.test(obj.ref.current.value))) && (
                <CheckIcon
                  style={{
                    color: "white",
                    background: "rgba(51, 207, 141, 1)",
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
            {obj.ref.current && obj.ref.current.value && !obj.regexp && (
              <CheckIcon
                style={{
                  color: "white",
                  background: "rgba(51, 207, 141, 1)",
                  borderRadius: "36px",
                  fontSize: "13px",
                  margin: "0px 3px",
                }}
              />
            )}
            {obj.ref.current &&
              obj.ref.current.value &&
              obj.regexp &&
              ((obj.label !== "Email" &&
                obj.regexp.test(obj.ref.current.value)) ||
                (obj.label === "Email" &&
                  !obj.regexp.test(obj.ref.current.value))) && (
                <CloseIcon
                  style={{
                    color: "white",
                    background: "rgb(241 3 3)",
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
          </ContentField>
        );
      default:
        break;
    }
  };

  const validateData = () => {
    let data = {};
    let missingData = false;
    let errorData = false;
    for (let index = 0; index < fields.length; index++) {
      if (
        fields[index].mandatory &&
        ((fields[index].type === "select" &&
          fields[index].ref.current.value === "0") ||
          (fields[index].type === "text" &&
            fields[index].ref.current.value === "") ||
          (fields[index].type === "textarea" &&
            fields[index].ref.current.value === ""))
      ) {
        missingData = true;
        break;
      } else if (
        (fields[index].label === "Email" &&
          fields[index].regexp &&
          !fields[index].regexp.test(fields[index].ref.current.value)) ||
        (fields[index].label !== "Email" &&
          fields[index].regexp &&
          fields[index].regexp.test(fields[index].ref.current.value))
      ) {
        errorData = true;
        break;
      } else {
        data[fields[index].label.replaceAll(" ", "")] =
          fields[index].type === "select"
            ? fields[index].ref.current.state.ariaSelection?.value?.value
            : fields[index].ref.current.value;
      }
      if (index === fields.length - 1) {
        if (files.file) {
          data["file"] = files.file;
        }
      }
    }

    if (!missingData && !errorData) {
      if (action === "add") createNewSpeaker(data, folderName);
      return;
    }
    if (errorData)
      NotificationManager.warning("there are errors in the fields", "", 5000);
    else if (missingData)
      NotificationManager.warning("Missing fields", "", 5000);
  };

  useEffect(() => {
    let countriesData = [];
    countries.getData().map((m) => {
      let dto = {
        value: m.code,
        label: m.name,
      };
      countriesData.push(dto);
    });
    setcountriesIso(countriesData);
  }, []);
  return (
    <ContentCreateSpeaker>
      <div
        style={{
          color: themeConfig.text.primary,
          fontWeight: "700",
          fontSize: "15px",
          display: "flex",
          padding: "0 0.4em",
        }}
      >
        General Information
      </div>
      <ContentFields>
        {fields.map((f, index) => renderInputs(f, index))}
        <ContentFile>
          <label>
            Speaker Cover Image
            <span style={{ color: themeConfig.text.disabled, fontStyle: "italic" }}>
              (Optional)
            </span>
          </label>
          <FileUpload
            accept=".jpg,.png,.jpeg"
            setDataBulkUpload={setDataBulkUpload}
            setFiles={setFiles}
            files={files}
            greyUI={true}
          />
        </ContentFile>
      </ContentFields>
      <ContentButtons>
        <ButtonCancel onClick={() => cancelFn()}>Cancel</ButtonCancel>
        <ButtonCreate
          onClick={() => {
            validateData();
          }}
        >
          Create Speaker
        </ButtonCreate>
      </ContentButtons>
    </ContentCreateSpeaker>
  );
};
export default CreateSpeakerComponent;
